export const ckeditorConfigs = {
    rubrics: {
        contentsCss: 'test',
        bodyClass: 'mybodyclass',
        toolbar: {
            items: [
                'heading',
                'fontBackgroundColor',
                'bold',
                'italic',
                'underline',
                '|',
                'bulletedList',
                'numberedList',
                'blockQuote',
                'undo',
                'redo'
            ]
        },
        table: {
            contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
        }
    }
};